import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { Organization } from '../models/organization';
import { OrganizationUser } from '../models/organization-user';
import { Country } from '../../models/country';
import { DelegateUser } from '../../models/delegate-model';
import { CommonHelperService } from '../../common/services/common-helper.service';
import { AuthService, AuthType, AUTH_TYPE_HEADER } from '../../../../shared/services/auth.service';
import { OrgSettings } from '../../models/org-settings.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
const httpFileOptions = {
  headers: new HttpHeaders({ 'Content-Type': undefined })
};

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  constructor(private http: HttpClient
    , private commonHelperService: CommonHelperService
    , private _authService: AuthService) {
  }

  getOrganization(): Observable<HttpResponse<Organization>> {
    return this.http.get<Organization>('/organization/getorganization', { observe: 'response', headers: this._authService.buildAuthHeader(AuthType.ESP) });
  }

  updateOrganization(organization: Organization): Observable<any> {
    return this.http.put<any>('/organization', organization, this._authService.espOptions);
  }

  //deleteOrganizationLogo(): Observable<any> {
  //  return this.http.delete<any>('/organization/logo', httpOptions);
  //}

  addUpdateOrganizationLogo(data: any): Observable<any> {
    return this.http.post<any>('/organization/logo', data, this._authService.espOptions);
  }

  getOrganizationLogo(): Observable<any> {
    return this.http.get<any>('/organization/logo', { headers: this._authService.buildAuthHeader(AuthType.ESP)});
  }

  getOrganizationUsers(): Observable<HttpResponse<OrganizationUser[]>> {
    return this.http.get<OrganizationUser[]>('/organization/users', { observe: 'response', headers: this._authService.buildAuthHeader(AuthType.ESP) });
  }

  async asyncGetOrganizationUsers() {
    return await this.http.get<OrganizationUser[]>('/organization/users', { observe: 'response', headers: this._authService.buildAuthHeader(AuthType.ESP) }).toPromise();
  }

  getCountries(): Observable<HttpResponse<Country[]>> {
    return this.http.get<Country[]>('/country/all', { observe: 'response', headers: this._authService.buildAuthHeader(AuthType.ESP) });
  }

  addOrganizationUser(organizationUser: any): Observable<any> {
    return this.http.post<any>('/orguser', organizationUser, this._authService.espOptions);
  }

  updateOrganizationUser(organizationUser: OrganizationUser): Observable<any> {
    return this.http.put<any>('/orguser', organizationUser, this._authService.espOptions);
  }

  updateOrganizationUserRole(organizationUser: OrganizationUser): Observable<any> {
    return this.http.put<any>('/orguser', organizationUser, this._authService.espOptions);
  }

  updateOrganizationUserImage(organizationUserId: number, data): Observable<any> {
    if (organizationUserId == undefined || organizationUserId == null) {
      organizationUserId = 0;
    }
    return this.http.post<any>('/orguser/uploadimage/' + organizationUserId, data, this._authService.espOptions);
  }

  //deleteOrganizationUserImage(organizationUserId: number): Observable<any> {
  //  return this.http.delete<any>('/orguser/deleteimage/' + organizationUserId, httpOptions);
  //}

  reinviteOrganizationUser(organizationUserId: number): Observable<any> {
    return this.http.post<any>('/orguser/reinvite/' + organizationUserId, {}, this._authService.espOptions);
  }

  activateOrganizationUser(organizationUserId: number): Observable<any> {
    return this.http.post<any>('/orguser/activateuser/' + organizationUserId, {}, this._authService.espOptions);
  }

  canDeactivateOrganizationUser(organizationUserId: number): Observable<any> {
    let headers = this.commonHelperService.getCurrentLocaleHeader();
    headers.append(AUTH_TYPE_HEADER, AuthType.ESP);
    return this.http.get<any>('/orguser/candeactivateuser/' + organizationUserId, { headers: headers });
  }

  deactivateOrganizationUser(organizationUserId: number): Observable<any> {
    return this.http.post<any>('/orguser/deactivateuser/' + organizationUserId, {}, this._authService.espOptions);
  }

  postDelegatedUser(delegateUser: DelegateUser): Observable<any> {
    return this.http.post<any>('/delegate/', delegateUser, this._authService.espOptions);
  }

  revokeDelegatedUser(delegateUser: DelegateUser): Observable<any> {
    return this.http.put<any>('/delegate/revoke/', delegateUser, this._authService.espOptions);
  }
  // postDelegatedUser(): Observable<any> {
  //     return this.http.post<any>('/delegate/', {});
  // }
  getOrgSettings(): Observable<OrgSettings> {
    return this.http.get<OrgSettings>('/orgSettings');
  }

  setConnectedAppInfo(groupBaseUrl: string, ssBaseUrl: string, ssOrgId: string, technadoptBaseUrl: string, groupName: string): Observable<any> {
    let data = {
      groupBaseUrl: groupBaseUrl,
      sSBaseUrl: ssBaseUrl,
      sSOrgId: ssOrgId, 
      technadoptBaseUrl: technadoptBaseUrl,
      groupName: groupName
    }
    return this.http.post<any>('/organization/setConnectedAppInfo', data, this._authService.espOptions);
  }
}
